import { render, staticRenderFns } from "./GiftCardBase.vue?vue&type=template&id=c43a6cac&"
import script from "./GiftCardBase.vue?vue&type=script&lang=js&"
export * from "./GiftCardBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports